import React, { Component } from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ChromePicker } from 'react-color'
import ReactHtmlParser from 'react-html-parser';
import SelectPosition from './SelecPosition'
import Select from "react-select";
import Preloader from '../../../GeneralComponents/LoadingComponen';

// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';


import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins.pkgd.min.js'

import 'froala-editor/js/languages/es';

import FroalaEditor from 'react-froala-wysiwyg';
import { array } from 'prop-types';

class ModalConfigurationDate extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            configuration_question_date: {
                has_traffic_light: "",
                first_color: "",
                second_color: "",
                third_color: "",
                email_next_to_end: "",
                email_ended: "",
                email_ended_summary: "",
                next_to_end_day: "",
                days_after_ended: "",
                external_email_question_id: "",
                external_email_question: "",
                question_compare_id: "",
                question_compare: "",
                value_to_compare: "",
                positions: [],
                questions: [],
                position_ids: [],
                question_ids: []
            },

            selectedOptionCargo: {
                position_ids: [],
                label: "Cargos"
            },

            selectedOptionQuestions: {
                question_ids: [],
                label: "Preguntas"
            },

            selectedOptionExternalEmailQuestion: {
                external_email_question_id: "",
                label: "Pregunta"
            },

            selectedOptionQuestion: {
                question_compare_id: "",
                label: "Pregunta"
            },

            showPikerFirstColor: false,
            showPikerSecondColor: false,
            showPikerThirdColor: false,

            showEmailNex: false,
            isLoaded: true,
            showEmailEnd: false,

            ErrorValues: true,

            cargos: [],
            editValues: [],
            questions: [],
            emailQuestions: [],
            positions: []            
        }
    }

    //select position

    componentDidMount = () => {
        this.loadData();
        this.setDefaultValues();
    }

    loadData = () => {
        fetch(`/formatos/get_configuration_question_date_register/${this.props.question.configuration_question_date.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.updateConfigurationQuestionDateState(data.register);
        });
    }

    updateConfigurationQuestionDateState = (configuration_question_date) => {
        let arrayQuestionIds = [];
        let arrayPositionIds = [];

        configuration_question_date.questions.map((item) => (
            arrayQuestionIds.push(item.value)
        ))

        configuration_question_date.positions.map((item) => (
            arrayPositionIds.push(item.value)
        ))       

        this.setState({
            isLoaded: false,
            configuration_question_date: {
                has_traffic_light: configuration_question_date.has_traffic_light,
                first_color: configuration_question_date.first_color,
                second_color: configuration_question_date.second_color,
                third_color: configuration_question_date.third_color,
                email_next_to_end: configuration_question_date.email_next_to_end,
                email_ended: configuration_question_date.email_ended,
                email_ended_summary: configuration_question_date.email_ended_summary,
                next_to_end_day: configuration_question_date.next_to_end_day,
                days_after_ended: configuration_question_date.days_after_ended,
                external_email_question_id: configuration_question_date.external_email_question_id,
                external_email_question: configuration_question_date.external_email_question,
                question_compare_id: configuration_question_date.question_compare_id,
                question_compare: configuration_question_date.question_compare,
                value_to_compare: configuration_question_date.value_to_compare,
                positions: configuration_question_date.positions,
                questions: configuration_question_date.questions,
                position_ids: arrayPositionIds,
                question_ids: arrayQuestionIds
            }
        })
    }

    setDefaultValues = () => {
        let arrayCargos = [];
        let arrayQuestions = [];
        let arrayEmailQuestions = [];

        this.props.positions.map((item) => (
            arrayCargos.push({ label: item.name, value: item.id })
        ))

        this.props.steps_questions.map((item) => (
            arrayQuestions.push({ label: item.question, value: item.id })
        ))

        this.props.steps_questions.map((item) => (
            item.question_type === "email" ? (
                arrayEmailQuestions.push({ label: item.question, value: item.id })
            ) : null
        ))
        console.log(arrayEmailQuestions)

        this.setState({
            cargos: arrayCargos,
            questions: arrayQuestions,
            emailQuestions: arrayEmailQuestions
        })
    }

    handleChangeAutocompleteExternalEmailQuestion = selectedOptionExternalEmailQuestion => {
        this.setState({
            selectedOptionExternalEmailQuestion,
                configuration_question_date: {
                    ...this.state.configuration_question_date,
                    external_email_question_id: selectedOptionExternalEmailQuestion.value
                }
          });
    }

    handleChangeAutocompleteQuestion = selectedOptionQuestion => {
        this.setState({
            selectedOptionQuestion,
                configuration_question_date: {
                    ...this.state.configuration_question_date,
                    question_compare_id: selectedOptionQuestion.value
                }
          });  
    }

    handleChangeAutocompleteCargo = selectedOption => {
        let array = []

        if (selectedOption != null) {
            selectedOption.map((item) => (
                array.push(item.value)
            ))

            this.setState({
                configuration_question_date: {
                    ...this.state.configuration_question_date,
                    position_ids: array
                }
            })

        } else {
            this.setState({
                configuration_question_date: {
                    ...this.state.configuration_question_date,
                    position_ids: []
                }
            })
        }
    }

    handleChangeAutocompleteQuestions = selectedOption => {
        let array = []

        if (selectedOption != null) {
            selectedOption.map((item) => (
                array.push(item.value)
            ))

            this.setState({
                configuration_question_date: {
                    ...this.state.configuration_question_date,
                    question_ids: array
                }
            })

        } else {
            this.setState({
                configuration_question_date: {
                    ...this.state.configuration_question_date,
                    question_ids: []
                }
            })
        }
    }

    //Primer color

    handleClickFirstColor = () => {
        this.setState({ showPikerFirstColor: !this.state.showPikerFirstColor })
    };

    handleCloseFirstColor = () => {
        this.setState({ showPikerFirstColor: false })
        this.updateStateConfigurationColor(this.state.configuration_question_date.first_color, "first_color")
    };

    handleChangeFirstColor = (color) => {
        this.setState({
            configuration_question_date: {
                ...this.state.configuration_question_date,
                first_color: color.hex,
            }
        })
    }

    //Segundo color 

    handleClickSecondColor = () => {
        this.setState({ showPikerSecondColor: !this.state.showPikerSecondColor })
    };

    handleCloseSecondColor = () => {
        this.setState({ showPikerSecondColor: false })
        this.updateStateConfigurationColor(this.state.configuration_question_date.second_color, "second_color")
    };

    handleChangeSecondColor = (color) => {
        this.setState({
            configuration_question_date: {
                ...this.state.configuration_question_date,
                second_color: color.hex,
            }
        })
    }

    //Tercer color

    handleClickThirdColor = () => {
        this.setState({ showPikerThirdColor: !this.state.showPikerThirdColor })
    };

    handleCloseThirdColor = () => {
        this.setState({ showPikerThirdColor: false })
        this.updateStateConfigurationColor(this.state.configuration_question_date.third_color, "third_color")
    };

    handleChangeThirdColor = (color) => {
        this.setState({
            configuration_question_date: {
                ...this.state.configuration_question_date,
                third_color: color.hex,
            }
        })
    }


    updateStateConfiguration = (state, countryside) => {
        fetch(`/formatos/update_state_configuration/${this.props.question.configuration_question_date.id}/${state}/${countryside}`, {
            method: 'PATCH', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })

        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.updateConfigurationQuestionDateState(data.configuration_question_date)
        });
    }

    updateStateConfigurationColor = (color, campo) => {
        color = color.replace("#", "")
        fetch(`/formatos/update_color_configuration/${this.props.question.configuration_question_date.id}/${color}/${campo}`, {
            method: 'PATCH', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        
        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {

        });
    }

    validationForm = () => {
        if (this.state.configuration_question_date.next_to_end_day != "") {
            console.log("los campos estan llenos")
            this.setState({ ErrorValues: true })
            return true
        } else {
            console.log("los campos no se han llenado")
            this.setState({ ErrorValues: false })
            return false
        }
    }

    updateTextExternalEmailQuestion = () => {
        if (this.validationForm()){
            fetch(`/formatos/update_state_config_question/${this.props.question.configuration_question_date.id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(this.state.configuration_question_date), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })

            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.updateConfigurationQuestionDateState(data.configuration_question_date)
                this.setState({
                    selectedOptionExternalEmailQuestion: {
                        external_email_question_id: "",
                        label: "Pregunta"
                    },
                })
            });
        }
    }

    updateText = () => {
        if (this.validationForm()){
            fetch(`/formatos/update_state_config_question/${this.props.question.configuration_question_date.id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(this.state.configuration_question_date), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })

            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.updateConfigurationQuestionDateState(data.configuration_question_date)
                this.setState({
                    selectedOptionQuestion: {
                        question_compare_id: "",
                        label: "Pregunta"
                    },

                    showEmailEnd: false,
                    showEmailNex: false,
                })
            });
        }
    }

    HandleChangeUpdateConfigurationEmailEndedSummary = (e) => {        
        this.setState({
            configuration_question_date: {
                ...this.state.configuration_question_date,
                email_ended_summary: e,
            }
        })
    }

    HandleChangeUpdateConfigurationEmailNex = (e) => {        
        this.setState({
            configuration_question_date: {
                ...this.state.configuration_question_date,
                email_next_to_end: e,
            }
        })
    }

    HandleChangeUpdateConfigurationEmailEnded = (e) => {        
        this.setState({
            configuration_question_date: {
                ...this.state.configuration_question_date,
                email_ended: e,
            }
        })
    }

    HandleChangeUpdateConfigurationNexDay = (e) => {
        this.setState({
            configuration_question_date: {
                ...this.state.configuration_question_date,
                [e.target.name]: e.target.value,
            }
        })
    }
    

    clearValues = () => {
        this.setState({
            /*
            configuration_question_date: {
                ...this.state.configuration_question_date,
                email_ended: this.props.question.configuration_question_date.email_ended,
                email_next_to_end: this.props.question.configuration_question_date.email_next_to_end,
            },
            */


            selectedOptionCargo: {
                position_ids: "",
                label: "Cargos"
            },

            showEmailEnd: false,
            showEmailNex: false,
        })
    }
                                                                                                                                             
    render() {

        const popover = {
            position: 'absolute',
            zIndex: '2',
        }

        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }

        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered modal-lg" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}>
                        <div className='ui-modals-header-title__container'>
                            <span className='ui-titles_modals'>
                                <i className="app-menu__icon fa fa-user mr-2"></i>
                                {this.props.title}
                            </span>
                            <span className='ui-name-question-modals ui-icon-in-title'>Pregunta {this.props.question.question}</span> 
                        </div>
                    </ModalHeader>

                        <ModalBody>
                            <div className="row">
                                {!this.state.isLoaded ? (
                                    <React.Fragment>
                                        <div className="col-md-12">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" onChange={(e) => this.updateStateConfiguration(!this.state.configuration_question_date.has_traffic_light, "show_traffic_light")} className="custom-control-input" id={`customStateTraffic`} checked={this.state.configuration_question_date.has_traffic_light} />
                                                <label className="custom-control-label" htmlFor={`customStateTraffic`}>¿Tiene semáforo?</label>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <hr/>
                                        </div>

                                        {this.state.configuration_question_date.has_traffic_light && (
                                            <React.Fragment>
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            Configuración de colores del semáforo
                                                        </div>
                                                        <div className="card-body">

                                                            <div className="row">
                                                                <div className="col-md-4 text-center">
                                                                    <button 
                                                                        onClick={this.handleClickFirstColor} 
                                                                        style={{ backgroundColor: this.state.configuration_question_date.first_color }}
                                                                        className="btn-traffic">
                                                                            Vigente
                                                                    </button>
                                                                    { this.state.showPikerFirstColor ? <div style={ popover }>
                                                                    <div style={ cover } onClick={ this.handleCloseFirstColor }/>
                                                                    <ChromePicker 
                                                                        color={this.state.configuration_question_date.first_color} 
                                                                        onChange={this.handleChangeFirstColor} 
                                                                    />
                                                                    </div> : null }
                                                                </div>


                                                                <div className="col-md-4 text-center">
                                                                    <button 
                                                                        onClick={this.handleClickSecondColor} 
                                                                        style={{ backgroundColor: this.state.configuration_question_date.second_color }}
                                                                        className="btn-traffic">
                                                                            Próximo
                                                                    </button>
                                                                    { this.state.showPikerSecondColor ? <div style={ popover }>
                                                                    <div style={ cover } onClick={ this.handleCloseSecondColor }/>
                                                                    <ChromePicker 
                                                                        color={this.state.configuration_question_date.second_color} 
                                                                        onChange={this.handleChangeSecondColor} 
                                                                    />
                                                                    </div> : null }
                                                                </div>

                                                                <div className="col-md-4 text-center">
                                                                    <button 
                                                                        onClick={this.handleClickThirdColor} 
                                                                        style={{ backgroundColor: this.state.configuration_question_date.third_color }}
                                                                        className="btn-traffic">
                                                                            Vencido
                                                                    </button>
                                                                    { this.state.showPikerThirdColor ? <div style={ popover }>
                                                                    <div style={ cover } onClick={ this.handleCloseThirdColor }/>
                                                                    <ChromePicker 
                                                                        color={this.state.configuration_question_date.third_color} 
                                                                        onChange={this.handleChangeThirdColor} 
                                                                    />
                                                                    </div> : null }
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )}

                                        <div className="col-md-12 mt-3 mb-3">
                                            <div className="card">
                                                <div className="card-header">
                                                    Configuración de notificaciones del semáforo al correo electrónico
                                                </div>
                                                <div className="card-body">
                                                    {this.state.showEmailNex ? (
                                                        <React.Fragment>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <b>Cargos a los cuales se les va a enviar los emails</b>
                                                                    <SelectPosition
                                                                        handleChangeAutocomplete={this.handleChangeAutocompleteCargo}
                                                                        value={this.state.selectedOptionCargo.position_ids}
                                                                        name={"position_ids"}
                                                                        options={this.state.cargos}
                                                                        editValues={this.state.configuration_question_date.positions}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <b>Dias</b>
                                                                    <input 
                                                                        type="number" 
                                                                        name="next_to_end_day"
                                                                        className={`form form-control ${this.state.ErrorValues == false && this.state.configuration_question_date.next_to_end_day == "" ? "error-class" : ""}`}
                                                                        onChange={this.HandleChangeUpdateConfigurationNexDay}
                                                                        value={this.state.configuration_question_date.next_to_end_day}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <b>Dias</b>
                                                                    <input 
                                                                        type="number" 
                                                                        name="days_after_ended"
                                                                        className={`form form-control ${this.state.ErrorValues == false && this.state.configuration_question_date.days_after_ended == "" ? "error-class" : ""}`}
                                                                        onChange={this.HandleChangeUpdateConfigurationNexDay}
                                                                        value={this.state.configuration_question_date.days_after_ended}
                                                                    />
                                                                </div>

                                                                <div className="col-md-12 mt-3 ui-modalConfigurationDate__container_froala">
                                                                    <div className="">
                                                                        <h6>Así se verá el correo electrónico cuando existan registros próximos a vencer y/o vencidos</h6>
                                                                    </div>

                                                                    <FroalaEditor
                                                                        model={this.state.configuration_question_date.email_ended_summary}
                                                                        config={this.props.config}
                                                                        onModelChange={this.HandleChangeUpdateConfigurationEmailEndedSummary}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6 mt-3 ui-modalConfigurationDate__container_froala">
                                                                    <div className="">
                                                                        <h6>Así se verá el correo electrónico cuando el registro esté próximo a vencer</h6>
                                                                    </div>

                                                                    <FroalaEditor
                                                                        model={this.state.configuration_question_date.email_next_to_end}
                                                                        config={this.props.config}
                                                                        onModelChange={this.HandleChangeUpdateConfigurationEmailNex}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6 mt-3">
                                                                    <div className="">
                                                                        <h6>Así ser verá el correo electrónico cuando el registro esté vencido</h6>
                                                                    </div>

                                                                    <FroalaEditor
                                                                        model={this.state.configuration_question_date.email_ended}
                                                                        config={this.props.config}
                                                                        onModelChange={this.HandleChangeUpdateConfigurationEmailEnded}
                                                                    />
                                                                </div>

                                                                <div className='col-md-12 mt-3'>
                                                                    <input
                                                                        type="hidden"
                                                                        name="external_email_question_id"
                                                                        value={this.state.selectedOptionExternalEmailQuestion.external_email_question_id}
                                                                    />
                                                                    <label>Pregunta con los emails externos (debe ser una pregunta tipo email)</label>
                                                                    <Select
                                                                        onChange={this.handleChangeAutocompleteExternalEmailQuestion}
                                                                        options={this.state.emailQuestions}
                                                                        autoFocus={false}
                                                                        className={`link-form`}
                                                                        value={this.state.selectedOptionExternalEmailQuestion}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6 mt-3">
                                                                    <input
                                                                        type="hidden"
                                                                        name="question_compare_id"
                                                                        value={this.state.selectedOptionQuestion.question_compare_id}
                                                                    />
                                                                    <label>Pregunta</label>
                                                                    <Select
                                                                        onChange={this.handleChangeAutocompleteQuestion}
                                                                        options={this.state.questions}
                                                                        autoFocus={false}
                                                                        className={`link-form`}
                                                                        value={this.state.selectedOptionQuestion}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6 mt-3">
                                                                    <label>Valor a comparar</label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="value_to_compare"
                                                                        className={`form form-control`}
                                                                        onChange={this.HandleChangeUpdateConfigurationNexDay}
                                                                        value={this.state.configuration_question_date.value_to_compare}
                                                                    />
                                                                </div>

                                                                <div className="col-md-12 mt-3">
                                                                    <label>Preguntas que quieres ver</label>
                                                                    <SelectPosition
                                                                        handleChangeAutocomplete={this.handleChangeAutocompleteQuestions}
                                                                        value={this.state.selectedOptionQuestions.question_ids}
                                                                        name={"question_ids"}
                                                                        options={this.state.questions}
                                                                        editValues={this.state.configuration_question_date.questions}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </React.Fragment>
                                                    ) : (
                                                        <React.Fragment>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <b>Cargos a los cuales se les va a enviar los emails </b>

                                                                    <ul>
                                                                        {this.state.configuration_question_date.positions.map((cargo, index) => (
                                                                            <React.Fragment>
                                                                                <li>{cargo.label}</li>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <b>Dias (restantes para que el semáforo cambie a estado próximo a vencer)</b>
                                                                    <p style={{fontSize:"20px"}}>{this.state.configuration_question_date.next_to_end_day}</p>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <b>Dias (para detener los correos de registros vencidos, 0 significa que nunca se detienen)</b>
                                                                    <p style={{fontSize:"20px"}}>{this.state.configuration_question_date.days_after_ended}</p>
                                                                </div>
                                                                <div className="col-md-12"><hr/></div>    
                                                                <div className="col-md-12">
                                                                    <b>Así se verá el correo electrónico cuando existan registros próximos a vencer y/o vencidos</b>
                                                                    <div className="send-format-email mb-3 mt-2">
                                                                        {ReactHtmlParser(this.state.configuration_question_date.email_ended_summary)}
                                                                    </div>
                                                                </div>          
                                                                <div className="col-md-6">
                                                                    <b>Así se verá el correo electrónico cuando el registro esté próximo a vencer</b>
                                                                    <div className="send-format-email mb-3 mt-2">
                                                                        {ReactHtmlParser(this.state.configuration_question_date.email_next_to_end)}
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="col-md-6">
                                                                    <b>Así ser verá el correo electrónico cuando el registro esté vencido</b>
                                                                    <div className="send-format-email mt-2">
                                                                        {ReactHtmlParser(this.state.configuration_question_date.email_ended)}
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <b>Pregunta con los emails externos (debe ser una pregunta tipo email)</b>
                                                                    <p>{this.state.configuration_question_date.external_email_question != null ? this.state.configuration_question_date.external_email_question.question : ""}</p>
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <b>Pregunta</b>
                                                                    <p>{this.state.configuration_question_date.question_compare != null ? this.state.configuration_question_date.question_compare.question : ""}</p>
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <b>Valor a comparar</b>
                                                                    <p>{this.state.configuration_question_date.value_to_compare}</p>
                                                                </div>

                                                                <div className="col-md-12 mt-3">
                                                                    <b>Preguntas que quieres ver</b>
                                                                    <ul>
                                                                        {this.state.configuration_question_date.questions.map((question, index) => (
                                                                            <React.Fragment>
                                                                                <li>{question.label}</li>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                                
                                                <div className="card-footer">
                                                    {this.state.showEmailNex ? (
                                                        <React.Fragment>
                                                            <button
                                                                className="btn-shadow btn btn-info mr-3" 
                                                                onClick={() => this.updateText()}
                                                            >
                                                                Aplicar cambios
                                                            </button>

                                                            <button
                                                                className="btn btn-outline-danger" 
                                                                onClick={() => this.clearValues()}
                                                            >
                                                                Cancelar
                                                            </button>
                                                        </React.Fragment>
                                                    ) : (
                                                        <button
                                                            className="btn-shadow btn btn-info mr-3" 
                                                            onClick={() => this.setState({ showEmailNex: true, showEmailEnd: false })}
                                                        >
                                                            Editar <i className="fas fa-pencil-alt"></i>
                                                        </button>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <Preloader />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <label className="btn btn-light mt-2" onClick={() => this.props.toggle()}>Cerrar</label>
                        </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}

export default ModalConfigurationDate;